module.exports = __webpack_public_path__ + "img/2.c15120a0.jpg";